import services from 'api/services';
import * as Constants from './constants';
import { logError } from 'util/errors';

const { TicketService, GDPRService, GDPRAgreementService, FeedbackService } = services;

export const loadTickets = () => async (dispatch) => {
  try {
    dispatch({ type: Constants.GET_LOAD_TICKETS_REQUEST });
    const response = await TicketService.loadTickets();
    dispatch({ type: Constants.GET_LOAD_TICKETS_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.GET_LOAD_TICKETS_FAILURE, error: ex.message });
  }
};

export const getCandidateCompanyConsent = (company) => async (dispatch) => {
  try {
    dispatch({ type: Constants.GET_GDPR_AGREEMENT_CONSENT_REQUEST });
    const gdprAgreementConsent = await GDPRService.hasCandidateCompanyConsent(company);
    dispatch({ type: Constants.GET_GDPR_AGREEMENT_CONSENT_SUCCESS, gdprAgreementConsent });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.GET_GDPR_AGREEMENT_CONSENT_FAILURE, error: ex.message });
  }
};

export const getCompanyGDPRAgreement = (company) => async (dispatch) => {
  try {
    dispatch({ type: Constants.GET_GDPR_AGREEMENT_REQUEST });
    const agreement = await GDPRAgreementService.getCompanyGDPRAgreement(company);
    dispatch({ type: Constants.GET_GDPR_AGREEMENT_SUCCESS, agreement });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.GET_GDPR_AGREEMENT_FAILURE, error: ex.message });
  }
};

export const setGDPRConsent = (company, body) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_GDPR_AGREEMENT_CONSENT_REQUEST });
    const gdpr = await GDPRService.setGDPR(company, body);
    dispatch({ type: Constants.SET_GDPR_AGREEMENT_CONSENT_SUCCESS, gdpr });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_GDPR_AGREEMENT_CONSENT_FAILURE, error: ex.message });
  }
};

export const updateCandidateTicketLocation = (ticketId, body) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_CANDIDATE_TICKET_LOCATION_REQUEST });
    const ticket = await TicketService.updateCandidateTicketLocation(ticketId, body);
    dispatch({ type: Constants.SET_CANDIDATE_TICKET_LOCATION_SUCCESS, ticket });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_CANDIDATE_TICKET_LOCATION_FAILURE, error: ex.message });
  }
};

export const updateCandidateChoosesTest = (ticketId, testId) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_CANDIDATE_CHOOSES_TEST_REQUEST });
    const ticket = await TicketService.updateCandidateChoosesTest(ticketId, testId);
    dispatch({ type: Constants.SET_CANDIDATE_CHOOSES_TEST_SUCCESS, ticket });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_CANDIDATE_CHOOSES_TEST_FAILURE, error: ex.message });
  }
};

export const updateSendOldReport = (ticketId, oldTicketId) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_SEND_OLD_REPORT_REQUEST });
    const ticket = await TicketService.updateSendOldReport(ticketId, oldTicketId);
    dispatch({ type: Constants.SET_SEND_OLD_REPORT_SUCCESS, ticket });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_SEND_OLD_REPORT_FAILURE, error: ex.message });
  }
};

export const createCandidateFeedback = (body) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_CREATE_CANDIDATE_FEEDBACK_REQUEST });
    const feedback = await FeedbackService.createCandidateFeedback(body);
    dispatch({ type: Constants.SET_CREATE_CANDIDATE_FEEDBACK_SUCCESS, feedback });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_CREATE_CANDIDATE_FEEDBACK_FAILURE, error: ex.message });
  }
};

export const resetState = () => async (dispatch) => {
  dispatch({ type: Constants.RESET_STATE });
};
